import { Features } from "../../features/types";

export default function getActionTypePrefix<T>(
  feature: Features | string,
  action: T | string
): string {
  return [feature, action].join("/");
}
